import { type I18nLocale, t } from '@ardoq/i18n';

export const getUnknownLabel = (i18nLocale: I18nLocale): string =>
  t(i18nLocale, 'provenance:unknown', 'Unknown');

export const getMissingRecordExplanation = (i18nLocale: I18nLocale): string =>
  t(
    i18nLocale,
    'provenance:missingRecordExplanation',
    'No source information was recorded for this data. It’s likely from before Ardoq started tracking data sources.'
  );
